<template>
  <ClientOnly>
    <Map v-bind="$attrs" />
    <template #fallback>
      <div w-full h-lg bg-stone-50 flex justify-center items-center text-stone-400 text-xl>Loading map&hellip;</div>
    </template>
  </ClientOnly>
</template>
<script setup></script>
